import { FiltersFieldIds } from '@epicuro-next/models/order-book';
import { FilterQueryItem } from 'graphql-api/baskets-api-interfaces';

// backend filters requested delivery date by using DeliveryDate_requested filter key
export const makeYearFilterQueryItem = (
  range: [string, string],
): FilterQueryItem => ({
  fieldId: FiltersFieldIds.DeliveryMonth,
  values: range,
});
